module.exports = __webpack_public_path__ + "img/caba_spring.73973a69.svg";